import { createReducer } from '../../store/reducerUtils';
import { SUBMITMODALMANAGE_ASYNC, ROLEQUERYINIT_ASYNC } from './saga';

export const key = 'role';

export const LOOK_AUTH = `${key}/LOOK_AUTH`;
export const MANAGE_AUTH = `${key}/MANAGE_AUTH`;
export const ADD_SELECT_ROLE = `${key}/ADD_ROLE`;
export const CHANGE_ROLENAME = `${key}/CHANGE_ROLENAME`;
export const CHANGE_ROLEDESC = `${key}/CHANGE_ROLEDESC`;
export const RANGEINIT = `${key}/RANGEINIT`;

export const ROLEQUERYINIT = `${key}/ROLEQUERYINIT`;
export const QUERYPERMISSION = `${key}/QUERYPERMISSION`;

export const HASHOBJ = `${key}/HASHOBJ`;

/* eslint-disable no-unused-vars */
/* eslint-disable object-shorthand */

export const initRoles = () => ({
  type: ROLEQUERYINIT_ASYNC,
});

export const handleSubmitModalManage = (option) => ({
  type: SUBMITMODALMANAGE_ASYNC,
  option: option,
});

export const changeManageRoleName = (name) => ({
  type: CHANGE_ROLENAME,
  modalManageName: name,
});

export const changeManageRoleDesc = (desc) => ({
  type: CHANGE_ROLEDESC,
  modalManageDesc: desc,
});

export const showLookAuth = (isShow) => ({
  type: LOOK_AUTH,
  isShow: isShow,
});

export const showManageAuth = (isShow) => ({
  type: MANAGE_AUTH,
  isShow: isShow,
});

export const addSelectRoles = (arr) => ({
  type: ADD_SELECT_ROLE,
  selects: arr,
});

const ACTION_HANDLERS = {
  [LOOK_AUTH]: (state, action) => {
    return {
      ...state,
      isLookAuth: action.isShow,
      isManageAuth: false,
    };
  },
  [MANAGE_AUTH]: (state, action) => {
    return {
      ...state,
      isLookAuth: false,
      isManageAuth: action.isShow,
    };
  },
  [ROLEQUERYINIT]: (state, action) => {
    return {
      ...state,
      roles: action.roles,
    };
  },
  [ADD_SELECT_ROLE]: (state, action) => {
    return {
      ...state,
      selects: action.selects,
    };
  },
  [QUERYPERMISSION]: (state, action) => {
    return {
      ...state,
      queryPermission: action.queryPermission,
    };
  },
  [CHANGE_ROLENAME]: (state, action) => {
    return {
      ...state,
      modalManageName: action.modalManageName,
    };
  },
  [CHANGE_ROLEDESC]: (state, action) => {
    return {
      ...state,
      modalManageDesc: action.modalManageDesc,
    };
  },
  [RANGEINIT]: (state, action) => {
    return {
      ...state,
      roleAndProduct: action.roleAndProduct,
    };
  },
  [HASHOBJ]: (state, action) => {
    return {
      ...state,
      hashObj: action.hashObj,
    };
  },
};

const initialState = {
  isLookAuth: false,
  isManageAuth: false,
  roles: [],
  selects: [],
  queryPermission: [],
  modalManageName: '',
  modalManageDesc: '',
  roleAndProduct: {},
  hashObj: {},
};

export default createReducer(initialState, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/views/Role/roleReducer.js